import React from 'react';
import { block } from '../../../utils/cn';
import './VideoView.css';
const b = block('stories-video-view');
export function VideoView({ media }) {
    return media.type === 'video' ? (React.createElement("video", { className: b(), src: media.url, controls: false, playsInline: true, muted: true, autoPlay: true, loop: true, "webkit-playsinline": "true", poster: media.posterUrl })) : null;
}
